import momentLocalTimezone from 'src/utils/momentLocalTimezone';

export default values => ({
  insurerId: values.insurer ?? null,
  agencyId: values.agency ?? null,
  coverageStart: values.coverageStart
    ? momentLocalTimezone(values.coverageStart)
    : null,
  coverageEnd: values.coverageEnd
    ? momentLocalTimezone(values.coverageEnd)
    : null,
  price: values.price ?? '',
  iva: values.iva,
  policyId: values.policyId ?? '',
  policyPdfUrl: values.policyPdfUrl
    ? {
        name: 'EQUIPMENT_VIEW.EQUIPMENT_DETAIL.VIEW_POLICY_PDF',
        link: values.policyPdfUrl,
        inDb: true
      }
    : null
});
